import { gql } from '@apollo/client'

export default gql`
  query CourseCollectionCardComponent_price($id: ID!) {
    productCollection(id: $id) {
      id
      price {
        currencyCode
        value
      }
      fullPrice {
        currencyCode
        value
      }
    }
  }
`
